import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_dashboard } from "../../store/services/authentication";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { FaUsers, FaStore, FaAd } from "react-icons/fa";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Dashboard() {
  const dispatch = useDispatch();
  const { get_dashboard_data, get_dashboard_status } = useSelector(
    (state) => state.userAuth
  );

  useEffect(() => {
    dispatch(get_dashboard());
  }, [dispatch]);

  const data = {
    labels: ["Vendors", "Users", "Ads"],
    datasets: [
      {
        label: "Count",
        data: [
          get_dashboard_data?.data?.vendors || 0,
          get_dashboard_data?.data?.users || 0,
          get_dashboard_data?.data?.ads || 0,
        ],
        backgroundColor: [
          "rgba(255, 99, 132, 0.7)",
          "rgba(54, 162, 235, 0.7)",
          "rgba(255, 206, 86, 0.7)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // यह जोड़ें
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 12, // लीजेंड आइटम का साइज कम करें
        },
      },
      title: {
        display: true,
        text: "Platform Statistics",
        font: {
          size: 16, // टाइटल फ़ॉन्ट साइज कम करें
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          font: {
            size: 12, // Y-एक्सिस फ़ॉन्ट साइज
          },
        },
        grid: {
          display: false, // ग्राइड लाइन्स हटाएं
        },
      },
      x: {
        ticks: {
          font: {
            size: 12, // X-एक्सिस फ़ॉन्ट साइज
          },
        },
        grid: {
          display: false, // ग्राइड लाइन्स हटाएं
        },
      },
    },
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">
        Dashboard Overview
      </h1>

      {get_dashboard_status === "loading" ? (
        <div className="text-center py-8 text-black">
          Loading dashboard data...
        </div>
      ) : get_dashboard_status === "error" ? (
        <div className="text-center py-8 text-red-500">
          Error loading dashboard data
        </div>
      ) : (
        <>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-md flex items-center">
              <div className="bg-blue-100 p-4 rounded-full mr-4">
                <FaUsers className="text-blue-600 text-2xl" />
              </div>
              <div>
                <h3 className="text-gray-500 text-sm font-medium">
                  Total Users
                </h3>
                <p className="text-2xl font-bold text-gray-900">
                  {get_dashboard_data?.data?.users || 0}
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md flex items-center">
              <div className="bg-green-100 p-4 rounded-full mr-4">
                <FaStore className="text-green-600 text-2xl" />
              </div>
              <div>
                <h3 className="text-gray-500 text-sm font-medium">
                  Total Vendors
                </h3>
                <p className="text-2xl font-bold text-gray-900">
                  {get_dashboard_data?.data?.vendors || 0}
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md flex items-center">
              <div className="bg-purple-100 p-4 rounded-full mr-4">
                <FaAd className="text-purple-600 text-2xl" />
              </div>
              <div>
                <h3 className="text-gray-500 text-sm font-medium">
                  Active Ads
                </h3>
                <p className="text-2xl font-bold text-gray-900">
                  {get_dashboard_data?.data?.ads || 0}
                </p>
              </div>
            </div>
          </div>

          {/* Chart Section */}
          <div className="bg-white p-4 rounded-lg shadow-md relative h-80 md:h-80 lg:h-96">
            <Bar data={data} options={options} />
          </div>
        </>
      )}
    </div>
  );
}

export default Dashboard;

// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { get_dashboard } from "../../store/services/authentication";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { FaUsers, FaStore, FaAd } from "react-icons/fa";

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function Dashboard() {
//   const dispatch = useDispatch();
//   const { get_dashboard_data, get_dashboard_status } = useSelector(
//     (state) => state.userAuth
//   );

//   useEffect(() => {
//     dispatch(get_dashboard());
//   }, [dispatch]);

//   // Data for line chart
//   const data = {
//     labels: ["January", "February", "March", "April", "May", "June"],
//     datasets: [
//       {
//         label: "Users",
//         data: [65, 59, 80, 81, 56, 55], // Replace with actual user data array
//         borderColor: "rgb(255, 99, 132)",
//         backgroundColor: "rgba(255, 99, 132, 0.5)",
//         tension: 0.4,
//       },
//       {
//         label: "Vendors",
//         data: [28, 48, 40, 19, 86, 27], // Replace with actual vendor data array
//         borderColor: "rgb(54, 162, 235)",
//         backgroundColor: "rgba(54, 162, 235, 0.5)",
//         tension: 0.4,
//       },
//       {
//         label: "Ads",
//         data: [12, 25, 35, 45, 55, 60], // Replace with actual ads data array
//         borderColor: "rgb(255, 206, 86)",
//         backgroundColor: "rgba(255, 206, 86, 0.5)",
//         tension: 0.4,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top",
//       },
//       title: {
//         display: true,
//         text: "Platform Statistics Trend",
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           stepSize: 1,
//         },
//       },
//     },
//     elements: {
//       line: {
//         borderWidth: 2,
//       },
//       point: {
//         radius: 5,
//         hoverRadius: 8,
//       },
//     },
//   };

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-3xl font-bold mb-6 text-gray-800">
//         Dashboard Overview
//       </h1>

//       {get_dashboard_status === "loading" ? (
//         <div className="text-center py-8 text-black">
//           Loading dashboard data...
//         </div>
//       ) : get_dashboard_status === "error" ? (
//         <div className="text-center py-8 text-red-500">
//           Error loading dashboard data
//         </div>
//       ) : (
//         <>
//           {/* Stats Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//             <div className="bg-white p-6 rounded-lg shadow-md flex items-center">
//               <div className="bg-blue-100 p-4 rounded-full mr-4">
//                 <FaUsers className="text-blue-600 text-2xl" />
//               </div>
//               <div>
//                 <h3 className="text-gray-500 text-sm font-medium">
//                   Total Users
//                 </h3>
//                 <p className="text-2xl font-bold text-gray-900">
//                   {get_dashboard_data?.data?.users || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="bg-white p-6 rounded-lg shadow-md flex items-center">
//               <div className="bg-green-100 p-4 rounded-full mr-4">
//                 <FaStore className="text-green-600 text-2xl" />
//               </div>
//               <div>
//                 <h3 className="text-gray-500 text-sm font-medium">
//                   Total Vendors
//                 </h3>
//                 <p className="text-2xl font-bold text-gray-900">
//                   {get_dashboard_data?.data?.vendors || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="bg-white p-6 rounded-lg shadow-md flex items-center">
//               <div className="bg-purple-100 p-4 rounded-full mr-4">
//                 <FaAd className="text-purple-600 text-2xl" />
//               </div>
//               <div>
//                 <h3 className="text-gray-500 text-sm font-medium">
//                   Active Ads
//                 </h3>
//                 <p className="text-2xl font-bold text-gray-900">
//                   {get_dashboard_data?.data?.ads || 0}
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Chart Section */}
//           {get_dashboard_status === "loading" ? (
//             <div className="text-center py-8 text-black">
//               Loading dashboard data...
//             </div>
//           ) : get_dashboard_status === "error" ? (
//             <div className="text-center py-8 text-red-500">
//               Error loading dashboard data
//             </div>
//           ) : (
//             <>
//               {/* Stats Cards (keep the same) */}
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//                 {/* Existing stats cards code */}
//               </div>

//               {/* Line Chart */}
//               <div className="bg-white p-6 rounded-lg shadow-md">
//                 <Line data={data} options={options} />
//               </div>
//             </>
//           )}
//         </>
//       )}
//     </div>
//   );
// }

// export default Dashboard;
